import * as turf from '@turf/turf';
import type { Feature, Polygon as GJPolygon } from 'geojson';
import { pointAreaLabel } from './map-point-editor.component';
import type { WhispFeatureLookup, WhispFeatureMark } from './whisp-feature-findings';

export interface MapListEntry {
  id: string;
  label: string;
  selected: boolean;
  hasError: boolean;
  whisp?: WhispFeatureMark;
}

export interface MapListInput {
  polygons: Feature<GJPolygon>[];
  points: Feature[];
  selectedIds: Set<string>;
  errorIds: (id: string) => boolean;
  areaLabel: string;
  pointLabel: string;
  whisp?: WhispFeatureLookup | null;
}

function areaHa(polygon: Feature<GJPolygon>): number {
  try {
    return (turf.area(polygon as any) as number) / 10000;
  } catch {
    return 0;
  }
}

export function buildMapList(input: MapListInput): MapListEntry[] {
  const polygons = input.polygons.map((f, i) => {
    const id = (f as any).id as string;
    const customName = String((f.properties as any)?.name ?? '').trim();
    return {
      id,
      label: `${customName || `${input.areaLabel} ${i + 1}`} – ${areaHa(f).toFixed(2)} ha`,
      selected: input.selectedIds.has(id),
      hasError: input.errorIds(id),
      whisp: input.whisp?.(f)?.mark,
    };
  });
  const points = input.points.map((feature, index) => ({
    id: String(feature.id),
    label: `${feature.properties?.['name'] || `${input.pointLabel} ${index + 1}`} – ${pointAreaLabel(feature.properties)}`,
    selected: input.selectedIds.has(String(feature.id)),
    hasError: false,
    whisp: input.whisp?.(feature)?.mark,
  }));
  return [...polygons, ...points];
}
